/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CloseTrackingSessionRequest } from '../models';
// @ts-ignore
import type { ListTrackingSessionsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { TrackingAction } from '../models';
// @ts-ignore
import type { TrackingSession } from '../models';
/**
 * TrackingAPIApi - axios parameter creator
 * @export
 */
export const TrackingAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Closes a tracking session, preventing further actions.  This is a custom method used for a specific lifecycle transition.
         * @param {string} organizationId The organization ID.
         * @param {string} id The session ID to close.
         * @param {CloseTrackingSessionRequest} closeTrackingSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingAPICloseTrackingSession: async (organizationId: string, id: string, closeTrackingSessionRequest: CloseTrackingSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('trackingAPICloseTrackingSession', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('trackingAPICloseTrackingSession', 'id', id)
            // verify required parameter 'closeTrackingSessionRequest' is not null or undefined
            assertParamExists('trackingAPICloseTrackingSession', 'closeTrackingSessionRequest', closeTrackingSessionRequest)
            const localVarPath = `/services/v1alpha/organizations/{organizationId}/tracking-sessions/{id}:close`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closeTrackingSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create tracking action
         * @param {string} organizationId The organization ID.
         * @param {string} trackingSessionId The tracking session ID.
         * @param {TrackingAction} trackingAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingAPICreateTrackingAction: async (organizationId: string, trackingSessionId: string, trackingAction: TrackingAction, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('trackingAPICreateTrackingAction', 'organizationId', organizationId)
            // verify required parameter 'trackingSessionId' is not null or undefined
            assertParamExists('trackingAPICreateTrackingAction', 'trackingSessionId', trackingSessionId)
            // verify required parameter 'trackingAction' is not null or undefined
            assertParamExists('trackingAPICreateTrackingAction', 'trackingAction', trackingAction)
            const localVarPath = `/services/v1alpha/organizations/{organizationId}/tracking-sessions/{trackingSessionId}/actions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"trackingSessionId"}}`, encodeURIComponent(String(trackingSessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackingAction, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create tracking session
         * @param {string} organizationId The organization ID.
         * @param {TrackingSession} trackingSession 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingAPICreateTrackingSession: async (organizationId: string, trackingSession: TrackingSession, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('trackingAPICreateTrackingSession', 'organizationId', organizationId)
            // verify required parameter 'trackingSession' is not null or undefined
            assertParamExists('trackingAPICreateTrackingSession', 'trackingSession', trackingSession)
            const localVarPath = `/services/v1alpha/organizations/{organizationId}/tracking-sessions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackingSession, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get tracking session
         * @param {string} organizationId The organization ID.
         * @param {string} id The session ID to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingAPIGetTrackingSession: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('trackingAPIGetTrackingSession', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('trackingAPIGetTrackingSession', 'id', id)
            const localVarPath = `/services/v1alpha/organizations/{organizationId}/tracking-sessions/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists tracking sessions
         * @param {string} organizationId The organization ID.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {TrackingAPIListTrackingSessionsStateEnum} [state] Filter for session state. If not specified, returns sessions in all states.
         * @param {string} [type] Filter for session type. If not specified, returns sessions of all types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingAPIListTrackingSessions: async (organizationId: string, pageLimit?: string, pageCursor?: string, state?: TrackingAPIListTrackingSessionsStateEnum, type?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('trackingAPIListTrackingSessions', 'organizationId', organizationId)
            const localVarPath = `/services/v1alpha/organizations/{organizationId}/tracking-sessions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackingAPIApi - functional programming interface
 * @export
 */
export const TrackingAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrackingAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Closes a tracking session, preventing further actions.  This is a custom method used for a specific lifecycle transition.
         * @param {string} organizationId The organization ID.
         * @param {string} id The session ID to close.
         * @param {CloseTrackingSessionRequest} closeTrackingSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingAPICloseTrackingSession(organizationId: string, id: string, closeTrackingSessionRequest: CloseTrackingSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingAPICloseTrackingSession(organizationId, id, closeTrackingSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingAPIApi.trackingAPICloseTrackingSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create tracking action
         * @param {string} organizationId The organization ID.
         * @param {string} trackingSessionId The tracking session ID.
         * @param {TrackingAction} trackingAction 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingAPICreateTrackingAction(organizationId: string, trackingSessionId: string, trackingAction: TrackingAction, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackingAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingAPICreateTrackingAction(organizationId, trackingSessionId, trackingAction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingAPIApi.trackingAPICreateTrackingAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create tracking session
         * @param {string} organizationId The organization ID.
         * @param {TrackingSession} trackingSession 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingAPICreateTrackingSession(organizationId: string, trackingSession: TrackingSession, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackingSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingAPICreateTrackingSession(organizationId, trackingSession, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingAPIApi.trackingAPICreateTrackingSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get tracking session
         * @param {string} organizationId The organization ID.
         * @param {string} id The session ID to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingAPIGetTrackingSession(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackingSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingAPIGetTrackingSession(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingAPIApi.trackingAPIGetTrackingSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists tracking sessions
         * @param {string} organizationId The organization ID.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {TrackingAPIListTrackingSessionsStateEnum} [state] Filter for session state. If not specified, returns sessions in all states.
         * @param {string} [type] Filter for session type. If not specified, returns sessions of all types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingAPIListTrackingSessions(organizationId: string, pageLimit?: string, pageCursor?: string, state?: TrackingAPIListTrackingSessionsStateEnum, type?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrackingSessionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingAPIListTrackingSessions(organizationId, pageLimit, pageCursor, state, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingAPIApi.trackingAPIListTrackingSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrackingAPIApi - factory interface
 * @export
 */
export const TrackingAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrackingAPIApiFp(configuration)
    return {
        /**
         * Closes a tracking session, preventing further actions.  This is a custom method used for a specific lifecycle transition.
         * @param {TrackingAPIApiTrackingAPICloseTrackingSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingAPICloseTrackingSession(requestParameters: TrackingAPIApiTrackingAPICloseTrackingSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.trackingAPICloseTrackingSession(requestParameters.organizationId, requestParameters.id, requestParameters.closeTrackingSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create tracking action
         * @param {TrackingAPIApiTrackingAPICreateTrackingActionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingAPICreateTrackingAction(requestParameters: TrackingAPIApiTrackingAPICreateTrackingActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackingAction> {
            return localVarFp.trackingAPICreateTrackingAction(requestParameters.organizationId, requestParameters.trackingSessionId, requestParameters.trackingAction, options).then((request) => request(axios, basePath));
        },
        /**
         * Create tracking session
         * @param {TrackingAPIApiTrackingAPICreateTrackingSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingAPICreateTrackingSession(requestParameters: TrackingAPIApiTrackingAPICreateTrackingSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackingSession> {
            return localVarFp.trackingAPICreateTrackingSession(requestParameters.organizationId, requestParameters.trackingSession, options).then((request) => request(axios, basePath));
        },
        /**
         * Get tracking session
         * @param {TrackingAPIApiTrackingAPIGetTrackingSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingAPIGetTrackingSession(requestParameters: TrackingAPIApiTrackingAPIGetTrackingSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackingSession> {
            return localVarFp.trackingAPIGetTrackingSession(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists tracking sessions
         * @param {TrackingAPIApiTrackingAPIListTrackingSessionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingAPIListTrackingSessions(requestParameters: TrackingAPIApiTrackingAPIListTrackingSessionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrackingSessionsResponse> {
            return localVarFp.trackingAPIListTrackingSessions(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.state, requestParameters.type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for trackingAPICloseTrackingSession operation in TrackingAPIApi.
 * @export
 * @interface TrackingAPIApiTrackingAPICloseTrackingSessionRequest
 */
export interface TrackingAPIApiTrackingAPICloseTrackingSessionRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPICloseTrackingSession
     */
    readonly organizationId: string

    /**
     * The session ID to close.
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPICloseTrackingSession
     */
    readonly id: string

    /**
     * 
     * @type {CloseTrackingSessionRequest}
     * @memberof TrackingAPIApiTrackingAPICloseTrackingSession
     */
    readonly closeTrackingSessionRequest: CloseTrackingSessionRequest
}

/**
 * Request parameters for trackingAPICreateTrackingAction operation in TrackingAPIApi.
 * @export
 * @interface TrackingAPIApiTrackingAPICreateTrackingActionRequest
 */
export interface TrackingAPIApiTrackingAPICreateTrackingActionRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPICreateTrackingAction
     */
    readonly organizationId: string

    /**
     * The tracking session ID.
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPICreateTrackingAction
     */
    readonly trackingSessionId: string

    /**
     * 
     * @type {TrackingAction}
     * @memberof TrackingAPIApiTrackingAPICreateTrackingAction
     */
    readonly trackingAction: TrackingAction
}

/**
 * Request parameters for trackingAPICreateTrackingSession operation in TrackingAPIApi.
 * @export
 * @interface TrackingAPIApiTrackingAPICreateTrackingSessionRequest
 */
export interface TrackingAPIApiTrackingAPICreateTrackingSessionRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPICreateTrackingSession
     */
    readonly organizationId: string

    /**
     * 
     * @type {TrackingSession}
     * @memberof TrackingAPIApiTrackingAPICreateTrackingSession
     */
    readonly trackingSession: TrackingSession
}

/**
 * Request parameters for trackingAPIGetTrackingSession operation in TrackingAPIApi.
 * @export
 * @interface TrackingAPIApiTrackingAPIGetTrackingSessionRequest
 */
export interface TrackingAPIApiTrackingAPIGetTrackingSessionRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPIGetTrackingSession
     */
    readonly organizationId: string

    /**
     * The session ID to retrieve.
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPIGetTrackingSession
     */
    readonly id: string
}

/**
 * Request parameters for trackingAPIListTrackingSessions operation in TrackingAPIApi.
 * @export
 * @interface TrackingAPIApiTrackingAPIListTrackingSessionsRequest
 */
export interface TrackingAPIApiTrackingAPIListTrackingSessionsRequest {
    /**
     * The organization ID.
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPIListTrackingSessions
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPIListTrackingSessions
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPIListTrackingSessions
     */
    readonly pageCursor?: string

    /**
     * Filter for session state. If not specified, returns sessions in all states.
     * @type {'STATE_UNSPECIFIED' | 'ACTIVE' | 'CLOSED'}
     * @memberof TrackingAPIApiTrackingAPIListTrackingSessions
     */
    readonly state?: TrackingAPIListTrackingSessionsStateEnum

    /**
     * Filter for session type. If not specified, returns sessions of all types.
     * @type {string}
     * @memberof TrackingAPIApiTrackingAPIListTrackingSessions
     */
    readonly type?: string
}

/**
 * TrackingAPIApi - object-oriented interface
 * @export
 * @class TrackingAPIApi
 * @extends {BaseAPI}
 */
export class TrackingAPIApi extends BaseAPI {
    /**
     * Closes a tracking session, preventing further actions.  This is a custom method used for a specific lifecycle transition.
     * @param {TrackingAPIApiTrackingAPICloseTrackingSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingAPIApi
     */
    public trackingAPICloseTrackingSession(requestParameters: TrackingAPIApiTrackingAPICloseTrackingSessionRequest, options?: RawAxiosRequestConfig) {
        return TrackingAPIApiFp(this.configuration).trackingAPICloseTrackingSession(requestParameters.organizationId, requestParameters.id, requestParameters.closeTrackingSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create tracking action
     * @param {TrackingAPIApiTrackingAPICreateTrackingActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingAPIApi
     */
    public trackingAPICreateTrackingAction(requestParameters: TrackingAPIApiTrackingAPICreateTrackingActionRequest, options?: RawAxiosRequestConfig) {
        return TrackingAPIApiFp(this.configuration).trackingAPICreateTrackingAction(requestParameters.organizationId, requestParameters.trackingSessionId, requestParameters.trackingAction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create tracking session
     * @param {TrackingAPIApiTrackingAPICreateTrackingSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingAPIApi
     */
    public trackingAPICreateTrackingSession(requestParameters: TrackingAPIApiTrackingAPICreateTrackingSessionRequest, options?: RawAxiosRequestConfig) {
        return TrackingAPIApiFp(this.configuration).trackingAPICreateTrackingSession(requestParameters.organizationId, requestParameters.trackingSession, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get tracking session
     * @param {TrackingAPIApiTrackingAPIGetTrackingSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingAPIApi
     */
    public trackingAPIGetTrackingSession(requestParameters: TrackingAPIApiTrackingAPIGetTrackingSessionRequest, options?: RawAxiosRequestConfig) {
        return TrackingAPIApiFp(this.configuration).trackingAPIGetTrackingSession(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists tracking sessions
     * @param {TrackingAPIApiTrackingAPIListTrackingSessionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingAPIApi
     */
    public trackingAPIListTrackingSessions(requestParameters: TrackingAPIApiTrackingAPIListTrackingSessionsRequest, options?: RawAxiosRequestConfig) {
        return TrackingAPIApiFp(this.configuration).trackingAPIListTrackingSessions(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.state, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const TrackingAPIListTrackingSessionsStateEnum = {
    STATE_UNSPECIFIED: 'STATE_UNSPECIFIED',
    ACTIVE: 'ACTIVE',
    CLOSED: 'CLOSED'
} as const;
export type TrackingAPIListTrackingSessionsStateEnum = typeof TrackingAPIListTrackingSessionsStateEnum[keyof typeof TrackingAPIListTrackingSessionsStateEnum];
